/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFriendliLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 40 40"
    {...props}
  >
    <path d="M33.409 0H6.59A6.591 6.591 0 0 0 0 6.591V33.41A6.591 6.591 0 0 0 6.591 40H33.41A6.591 6.591 0 0 0 40 33.409V6.59A6.591 6.591 0 0 0 33.409 0Z" />
    <g fill="#fff">
      <path d="M11.684 15.39a3.69 3.69 0 0 0 3.683-3.695A3.69 3.69 0 0 0 11.684 8 3.69 3.69 0 0 0 8 11.695a3.69 3.69 0 0 0 3.684 3.695Zm0 16.61a3.69 3.69 0 0 0 3.683-3.695 3.69 3.69 0 0 0-3.683-3.695A3.69 3.69 0 0 0 8 28.305 3.69 3.69 0 0 0 11.684 32Zm7.367-23.7h2.49c1.18 0 2.14.958 2.14 2.144v2.498a2.143 2.143 0 0 1-2.14 2.145h-2.795a1.837 1.837 0 0 1-1.833-1.838v-2.805c0-1.182.956-2.145 2.138-2.145Zm-6.066 15.096h-2.549a2.14 2.14 0 0 1-2.138-2.145v-2.498a2.14 2.14 0 0 1 2.138-2.145h1.986l1.443.102c1.142 0 1.259 2.714 1.259 2.714v1.83a2.15 2.15 0 0 1-2.139 2.145v-.003Z" />
      <path d="M12.418 16.604s1.371.055 2.248-.485c.687-.423 1.461-1.142 1.821-1.995.466-1.105.422-2.221.422-2.221l2.927 3.184s-1.341-.077-2.21.376c-1.011.529-1.422 1.083-1.851 1.754-.655 1.025-.655 2.506-.655 2.506l-2.702-3.119ZM29.93 8.398h-2.628c-1.143 0-2.07.929-2.07 2.075v2.637c0 1.146.927 2.075 2.07 2.075h2.629A2.072 2.072 0 0 0 32 13.11v-2.637a2.072 2.072 0 0 0-2.07-2.075Z" />
      <path d="M21.673 23.494h-2.63a2.073 2.073 0 0 1-2.068-2.075v-2.637c0-1.145.927-2.076 2.069-2.076h2.05l1.175.135c1.142 0 1.473.796 1.473 1.94v2.638a2.073 2.073 0 0 1-2.07 2.075Z" />
      <path d="M20.578 16.706s1.491.08 2.407-.299c.8-.332 1.691-1.258 1.946-2.024.302-.92.302-2.156.302-2.156l3.01 2.966s-.88-.059-1.8.423c-.865.452-1.745 1.353-2.109 2.064-.461.901-.589 2.79-.589 2.79l-3.163-3.76-.004-.004Z" />
    </g>
  </svg>
);

export default SvgFriendliLogo;
